export default __webpack_public_path__ + "static/media/3403a5d674fa3512bf6098d7dca93bff.e56b4db7.svg";